import { MCAContextProvider } from '@interhyp/module-case-assignment';
import { AuthenticationProviderBridge } from '@interhyp/platform-auth';
import { HeaderContext } from '@interhyp/platform-navigation';
import { ApplicationContext } from '@interhyp/util-application-context';
import { AuthenticationProvider } from '@interhyp/util-authentication';
import { getConnection } from '@interhyp/util-request';
import { withTracking, TrackingAdapter } from '@interhyp/util-tracking';
import i18next from 'i18next';
import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from '@interhyp/platform-router';

import { App } from './container/App';
import de from './i18n/de.json';
import { useLegacyIdentity } from '../hooks/useLegacyIdentity';
import { store } from '../redux/store';

i18next.addResourceBundle('de', 'app', de);

window.__conn = getConnection();
window.__conn.addHeader('Content-Type', 'application/json');

getConnection('website').addHeader('Content-Type', 'application/json');

const withTrackingProvider = Component => {
  return withTracking({ app: 'EhypSales' }, { dispatch: TrackingAdapter })(Component);
};

const authenticationConfig = {
  userServiceUrl: '/api/user-service',
};

function AuthenticatedApp() {
  const identity = useLegacyIdentity();
  return (
    <AuthenticationProviderBridge identity={identity}>
      <BrowserRouter>
        <Provider store={store}>
          <ApplicationContext>
            <MCAContextProvider>
              <HeaderContext>
                <App />
              </HeaderContext>
            </MCAContextProvider>
          </ApplicationContext>
        </Provider>
      </BrowserRouter>
    </AuthenticationProviderBridge>
  );
}

const AppWithRouterAndContext = withTrackingProvider(() => (
  <AuthenticationProvider config={authenticationConfig}>
    <AuthenticatedApp />
  </AuthenticationProvider>
));

export { AppWithRouterAndContext };
